import '../App.css';
import Logo from '../components/Logo';
import Socials from '../components/Socials';
import '../styles/footer.css';
import { Link } from 'react-router-dom';

interface props {
    callback?: (loc: string) => void,
    page?: string
}

function Footer({callback, page}: props) {
    return (
        <div className='footer'>
            <div className='footer-inner'>
                <div className='footer-left'>
                    <Logo size='small'/>
                </div>
                <div className='footer-center'>
                    <div className='footer-links'>
                    { page === 'events' ? 
                        <Link to="/" className="navigation-link">
                            About
                        </Link>
                    :
                        callback && <a href="#top" className="navigation-link" onClick={() => callback('about')}>About Us</a>
                    }
                        <Link to="/events" className="navigation-link">
                            Events
                        </Link>
                    </div>
                </div>
                <div className='footer-right'>
                    <Socials/>
                </div>
            </div>
        </div>
    );
}

export default Footer;
